import { makeStyles } from "@material-ui/core/styles";

import * as colors from "../../theme/colors";

export const useStyles = makeStyles({
  btnContainer: {
    backgroundColor: (props) => props.backgroundColor,
    border: 0,
    boxSizing: "border-box",
    color: (props) => props.mainColor,
    fontWeight: 700,
    fontSize: 16,
    position: "relative",
    verticalAlign: "middle",
    opacity: (props) => props.opacity,
    pointerEvents: (props) => props.pointerEvents,
    "&:hover": {
      color: (props) => props.onHoverColor,
      backgroundColor: (props) => props.onHoverBackgroundColor,
    }
  },
});

const ideStyle = {
  mainColor: colors.black,
  backgroundColor: colors.ideYellow500,
  onHoverColor: colors.black,
  onHoverBackgroundColor: colors.ideYellow600,
  opacity: 1,
  pointerEvents: "auto",
};

const disabledMode = (
  base,
  { color = colors.darkBlue900, background = base.backgroundColor, opacity = 1 } = {},
) => ({
  ...base,
  mainColor: color,
  backgroundColor: background,
  onHoverColor: color,
  onHoverBackgroundColor: background,
  opacity,
  pointerEvents: "none",
});

export const styleTypes = {
  curriculum: {
    mainColor: colors.darkBlue900,
    secondColor: colors.darkBlue900,
    borderColor: colors.lightThemeGreen,
    onHoverBackgroundColor: colors.lightThemeGreen,
    backgroundColor: colors.lightThemeGreen,
  },
  curriculumDisabled: {
    mainColor: colors.black,
    secondColor: colors.greyLight2,
    borderColor: colors.greyLight2,
    onHoverBackgroundColor: colors.greyLight2,
    backgroundColor: colors.greyLight2,
  },
  primary: {
    mainColor: colors.darkThemeGreen,
    backgroundColor: "transparent",
    onHoverColor: colors.darkThemeGreen,
    onHoverBackgroundColor: "transparent",
  },
  secondary: {
    mainColor: colors.darkThemeBlue,
    backgroundColor: "transparent",
    onHoverColor: colors.darkThemeBlue,
    onHoverBackgroundColor: "transparent",
  },
  menuItem: {
    mainColor: colors.darkBlue900,
    backgroundColor: "transparent",
    onHoverColor: colors.darkThemeGreen,
    onHoverBackgroundColor: "transparent",
  },
  activeItem: {
    mainColor: colors.darkThemeBlue,
    backgroundColor: colors.lightThemeGreen,
    onHoverColor: colors.darkThemeBlue,
    onHoverBackgroundColor: colors.darkThemeGreen,
  },
  disabled: {
    mainColor: colors.darkGrey100,
    backgroundColor: colors.white,
    onHoverColor: colors.greyLight2,
    onHoverBackgroundColor: colors.white,
  },
  ide: ideStyle,
  // TextJam: pale fill at full opacity.
  ideDisabled: disabledMode(ideStyle, { background: colors.ideYellow50 }),

  blockjam: ideStyle,
  // BlockJam: the original solid yellow at half opacity.
  blockjamDisabled: disabledMode(ideStyle, { opacity: 0.5 }),
};

export const isDisabledMode = (mode) => typeof mode === "string" && mode.endsWith("Disabled");

export const getStyles = (disabled, isActive, mode) => {
  if (!isActive) {
    return disabled
      ? (isDisabledMode(mode) && styleTypes[mode]
          ? styleTypes[mode]
          : styleTypes.disabled)
      : styleTypes[mode];
  }
  return styleTypes.activeItem;
}
